<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            Department of Agri Product Sale and Marketing/ B2B User
            
          </h2>
        </div>
      </div>
      <b-tabs v-model="activeTab" v-if="roleid==6 || roleid==7">
        <b-tab-item label="ຟອມເພີ່ມ/ ແກ້ໄຂຜູ້ໃຊ້">
         <div class="columns" >
            <div class="column">
              <h3 class="title">ເພິ່ມ/ ແກ້ໄຂຜູ້ໃຊ້</h3>
            </div>
          </div>
          <div class="columns" v-if="adddataform">
            <div class="column">
              <b-field>
                ຊື່ບໍລິສັດ/ລູກຄ້າ
              </b-field>
              <div class="columns">
                <div class="column">
                  <b-field >
                    ຊື່ບໍລິສັດ <span class="asterisk">*</span>
                  </b-field>
                  <b-field>
                    <b-input v-model.trim="company"> </b-input>
                  </b-field>
                </div>
                <div class="column">
                  <b-field >
                    Username <span class="asterisk">*</span>
                  </b-field>
                  <b-field v-if="saveAction">
                    <b-input v-model.trim="b2busername"> </b-input>
                  </b-field>
                  <b-field v-if="updateAction" :disabled="updateAction==true">
                    <span style="font-size: 18px; font-weight: bold;">{{ b2busername }}</span>
                  </b-field>
                </div>

                <div class="column">
                  <b-field >
                    Password <span v-if="saveAction" class="asterisk">*</span> 
                    <b-button v-if="updateAction && !ischangepassword"
                      class="btn-group-margin"
                      type="is-info"
                      size="is-small"
                      @click="isChangePassword"
                      >ປ່ຽນ Password
                    </b-button>
                  </b-field>
                  <b-field v-if="saveAction">

                    <b-input  v-model.trim="b2buserpassword" type="password" placeholder="password" style="margin-right: 5px;"> </b-input>
                    
                    <b-input v-model.trim="reb2buserpassword" type="password"  placeholder="re-password" style="margin-left: 5px;"> </b-input>

                  </b-field>
                  <b-field v-if="updateAction" :disabled="updateAction==true">
                    <b-input v-if="ischangepassword" v-model.trim="b2buserpassword" type="password" placeholder="password" style="margin-right: 5px;"> </b-input>
                    
                    <b-input v-if="ischangepassword" v-model.trim="reb2buserpassword" type="password"  placeholder="re-password" style="margin-left: 5px;"> </b-input>
                  </b-field>
                </div>
                
              
              </div>
            </div>
          </div>
          <br>
          <div class="columns" v-if="adddataform">
            <div class="column">
              <b-field>
                ທີ່ຢູ່
              </b-field>
              <div class="columns">
                <div class="column">
                  ປະເທດ <span class="asterisk">*</span>
                  <b-field label="">
                    <Multiselect
                      placeholder="ເລືອກ"
                      v-model.trim="SelectedCountry"
                      label="NAME"
                      track-by="ID"
                      :options="countryList"
                      @input="onCountrySelected"
                    >
                    </Multiselect>
                  </b-field>
                </div>
                <div class="column">
                  ແຂວງ <span class="asterisk">*</span>
                  <b-field label="">
                    <Multiselect 
                      placeholder="ເລືອກ"
                      v-model.trim="SelectedProvince"
                      label="NAME"
                      track-by="ID"
                      :options="ProvinceList"
                    >
                    </Multiselect>
                  </b-field>
                </div>
                <div class="column">
                  ເມືອງ <span class="asterisk">*</span>
                  <b-field label="">
                    <b-input v-model.trim="district"> </b-input>
                  </b-field>
                </div>
                <div class="column">
                  ບ້ານ <span class="asterisk">*</span>
                  <b-field label="">
                    <b-input v-model.trim="village"> </b-input>
                  </b-field>
                </div>
                
              </div>
            </div>
          </div>
          <br>
          <div class="columns" v-if="adddataform">
            <div class="column">
              <b-field>
                ຂໍ້ມູນຜູ້ຮັບຜິດຊອບ 
              </b-field>
              <div class="columns">
                <div class="column">
                    <b-field >
                      ຊື່ເຕັມ <span class="asterisk">*</span>
                    </b-field>
                    <b-field >
                      <b-input v-model.trim="fullname"> </b-input>
                    </b-field>
                  </div>
                  
                <div class="column">
                  <b-field >
                    ເບີໂທ <span class="asterisk">*</span>
                    </b-field>
                  <b-field > 
                    <b-input v-model.trim="phoneno"> </b-input>
                  </b-field>
                </div>
              </div>

            </div>
          </div>

          <div class="columns" v-if="adddataform">
            <div class="column">
              <div class="columns">
                
                
                <div class="column">
                  ລາຍລະອຽດເພີ່ມເຕີມ (ຖ້າມີ)
                  <b-field label="">
                    <b-input v-model.trim="moredetail"> </b-input>
                  </b-field>
                </div>
                
              </div>
              <div class="columns">
                
                
                <div class="column">
                  ການຮັບລາຄາໂປຣໂມຊັນ
                  <b-field label="">
                    <Multiselect
                      placeholder="ເລືອກ"
                      v-model.trim="selectedPromotionPrice"
                      label="NAME"
                      track-by="ID"
                      :options="promotionOptions"
                    >
                    </Multiselect>
                  </b-field>
                </div>
                <div class="column">

                </div>
                <div class="column">

                </div>
                <div class="column">

                </div>
                
              </div>
             
              <b-field label="" style="float: right">
                <b-field v-if="saveAction">
                  <button class="button is-info" @click="saveUser">
                    ບັນທຶກ
                  </button>
                </b-field>
                <b-field v-if="updateAction">
                  <div class="columns">
                    <div class="column">
                      <b-field>
                        <button
                          class="button is-primary"
                          @click="updateUser"
                        >
                          ແກ້ໄຂ
                        </button>
                      </b-field>
                    </div>
                    <div class="column">
                      <b-field>
                        <button
                          class="button is-info"
                          @click="openSaveUserForm"
                        >
                          ຟອມເພີ່ມຜູ້ໃຊ້
                        </button>
                      </b-field>
                    </div>
                  </div>
                </b-field>
              </b-field>
            </div>
          </div>

        </b-tab-item>

        <b-tab-item label="ຜູ້ໃຊ້ ທີ່ເປີດໃຊ້ງານ">
          <div class="columns scrollme">
            <div class="column">
              <div>
                <b-field group>
                  <b-field label="ຜູ້ໃຊ້ ທີ່ເປີດໃຊ້ງານ"></b-field>
                  <b-field
                    style="margin: 0 10px 0 10px;"
                  >
                    <router-link to="/dasm/b2bcontractquota"
                    >
                      <b-button
                        class="btn-group-margin"
                        type="is-primary"
                        size="is-small"
                        >ຈັດການສັນຍາ
                      </b-button> 
                    </router-link>
                  </b-field>
                </b-field>
                <table
                  class="table is-fullwidth is-narrow is-small"
                >
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>
                      <th class="has-text-left " width="15%">
                        ຊື່ເຂົ້າໃຊ້ລະບົບ
                      </th>
                      <th class="has-text-left " width="15%">
                        ຊື້ເຕັມ
                      </th>


                      <th class="has-text-left " width="15%">
                        ເບີໂທ
                      </th>
                      <th class="has-text-left " width="30%">
                        ທີ່ຢູ່
                      </th>
                     
                      <th class="has-text-left " width="10%">
                        ຈັດການ 
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in activeusers"
                      :key="data.USERID"
                      :style="{ backgroundColor: data.ISPROPRICE == 0 ? '#FAD2CF' : '' }"
                    >
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.USERNAME }}
                      </td>
                      <td>
                        {{ data.FULLNAME }}
                      </td>
                      <td>
                        {{ data.PHONENO }}
                      </td>
                      <td>
                        {{ data.PROVINCENAME }} {{ data.DISTRICT }} {{ data.VILLAGE }}
                      </td>
                     
                      <td class="has-text-centered">
                          <b-field group>
                           
                            <b-field>
                              <b-button class="btn-group-margin"
                                type="is-primary"
                                size="is-small"
                                @click="
                                  updateUserForm(
                                    data
                                  )"
                                >ແກ້ໄຂ
                              </b-button>
                            </b-field>
                            <b-field v-if="data.B2BTYPE ==2">
                              <b-button class="btn-group-margin"
                                type="is-info"
                                size="is-small"
                                @click="
                                  getSubB2B(data.USERNAME)"
                                >B2B ຍ່ອຍ
                              </b-button>
                            </b-field>
                            <b-field>
                              <b-button class="btn-group-margin"
                                type="is-warning"
                                size="is-small"
                                @click="
                                  resetPassword(
                                    data.USERID
                                  )"
                                >ລີເຊັດລະຫັດ
                              </b-button>
                            </b-field>
                            <b-field>
                              <b-button class="btn-group-margin"
                                type="is-danger"
                                size="is-small"
                                @click="
                                  changeUserStatus(data.USERID,0)"
                                >ປິດໃຊ້ງານ
                              </b-button>
                            </b-field>
                          </b-field>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </b-tab-item>

        
        <b-tab-item label="ຜູ້ໃຊ້ ທີ່ຖືກປິດ">
          <div class="columns scrollme">
            <div class="column">
              <b-field label="ຜູ້ໃຊ້ ທີ່ຖືກປິດ">
                <table
                  class="table is-fullwidth is-narrow is-small"
                >
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>
                      <th class="has-text-left " width="15%">
                        ຊື່ເຂົ້າໃຊ້ລະບົບ
                      </th>
                      <th class="has-text-left " width="15%">
                        ຊື້ເຕັມ
                      </th>

                      <th class="has-text-left " width="15%">
                        ເບີໂທ
                      </th>
                      <th class="has-text-left " width="30%">
                        ທີ່ຢູ່
                      </th>
                      <th class="has-text-left " width="10%">
                        ຈັດການ
                      </th>
                      
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in inactiveusers"
                      :key="data.ID"
                    >
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.USERNAME }}
                      </td>
                      <td>
                        {{ data.FULLNAME }}
                      </td>
                      <td>
                        {{ data.PHONENO }}
                      </td>
                      <td>
                        {{ data.PROVINCE }} {{ data.DISTRICT }} {{ data.VILLAGE }}
                      </td>
                      <td>
                        <b-field>
                              <b-button class="btn-group-margin"
                            type="is-primary"
                            size="is-small"
                            @click="
                              changeUserStatus(data.USERID,1)"
                            >ເປີດໃຊ້ງານ
                          </b-button>
                        </b-field>
                      </td>
                      
                      
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>
        <b-tab-item :label="b2bchangeinfo" >
          <div class="columns scrollme">
            <div class="column">
              <b-field label="ຜູ້ໃຊ້ ຂໍປ່ຽນຂໍ້ມູນ (ລະຫັດ)">
                <table
                  class="table is-fullwidth is-narrow is-small"
                >
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>
                      <th class="has-text-left " width="15%">
                        ຊື່ເຂົ້າໃຊ້ລະບົບ
                      </th>
                      <th class="has-text-left " width="15%">
                        ຊື້ເຕັມ
                      </th>

                      <th class="has-text-left " width="15%">
                        ເບີໂທ
                      </th>
                      <th class="has-text-left " width="30%">
                        ທີ່ຢູ່
                      </th>
                      <th class="has-text-left " width="10%">
                        ຈັດການ
                      </th>
                      
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in requestusers"
                      :key="data.ID"
                    >
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.USERNAME }}
                      </td>
                      <td>
                       
                      </td>
                      <td>
                       
                      </td>
                      <td>
                       
                      </td>
                      <td>
                        <b-field>
                              <b-button class="btn-group-margin"
                            type="is-primary"
                            size="is-small"
                            @click="
                              updateByUserRequest(data.USERNAME)"
                            >ອະນຸມັດ
                          </b-button>
                        </b-field>
                      </td>
                      
                      
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>
        <b-tab-item label="B2B ຍ່ອຍ" >
          <div class="columns scrollme" >
            <div class="column">
              <h3 class="title">ເພິ່ມ/ ແກ້ໄຂຜູ້ໃຊ້</h3>
            </div>
          </div>
          <div class="columns" v-if="adddataform">
            <div class="column">
      
              <div class="columns">
                <div class="column">
                  <b-field >
                    ຊື່ເຕັມ <span class="asterisk">*</span>
                  </b-field>
                  <b-field>
                    <b-input v-model.trim="subb2bfullname"> </b-input>
                  </b-field>
                </div>
                <div class="column">
                  <b-field >
                    ເບີໂທ <span class="asterisk">*</span>
                  </b-field>
                  <b-field >
                    <b-input v-model.trim="subb2bphoneno"> </b-input>
                  </b-field>
                 
                </div>

                <div class="column">
                  <b-field label="" style="float: right">
                    <b-field v-if="saveB2BAction">
                      <button class="button is-info" @click="saveSubB2B">
                        ບັນທຶກ
                      </button>
                    </b-field>
                    <b-field v-if="updateB2BAction">
                      <div class="columns">
                        <div class="column">
                          <b-field>
                            <button
                              class="button is-primary"
                              @click="updateSubB2B"
                            >
                              ແກ້ໄຂ
                            </button>
                          </b-field>
                        </div>
                        <div class="column">
                          <b-field>
                            <button
                              class="button is-info"
                              @click="openSaveSubB2BForm"
                            >
                              ຟອມເພີ່ມ B2B ຍ່ອຍ
                            </button>
                          </b-field>
                        </div>
                      </div>
                    </b-field>
                  </b-field>
                </div>
                
              
              </div>
            </div>
          </div>
          <div class="columns scrollme">
            <div class="column">
              <b-field label="B2B ຍ່ອຍ">
                <table
                  class="table is-fullwidth is-narrow is-small"
                >
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>
                      <th class="has-text-left " width="15%">
                        Username
                      </th>
                      <th class="has-text-left " width="15%">
                        ຊື່ເຕັມ
                      </th>
                      <th class="has-text-left " width="15%">
                        ເບີໂທ
                      </th>
                      <th class="has-text-left " width="10%">
                        ຈັດການ
                      </th>
                      
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in getSubB2BList"
                      :key="data.ID"
                    >
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.B2BUSERNAME }}
                      </td>
                      <td>
                        {{ data.FULLNAME }}
                      </td>
                      <td>
                        {{ data.PHONENO }}
                      </td>
                      <td>
                        <b-field>
                              <b-button class="btn-group-margin"
                            type="is-primary"
                            size="is-small"
                            @click="
                              updateSubB2BForm(data)"
                            >ແກ້ໄຂ
                          </b-button>
                        </b-field>
                      </td>
                      
                      
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>
      </b-tabs>
    </div>
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
import Multiselect from "vue-multiselect";
export default {
  components: { Multiselect },
  props: ["MONTH"],
  data() {
    return {
    roleid: null,
    username: null,
    b2buserid: null,
    b2busername: null,
    b2buserpassword: null,
    reb2buserpassword: null,
    fullname: null,
    company: null,
    oldfullname: null,
    phoneno: null,
    oldphoneno: null,

    activeusers: [],
    inactiveusers: [],

    activeTab: 1,
    saveAction: true,
    updateAction: false,
    adddataform: true,
    updatedataform: false,

    saveB2BAction: true,
    updateB2BAction: false,

    countryList: [],
    SelectedCountry: null,
    ProvinceList: [],
    SelectedProvince: null,
    district: null,
    village: null,
    moredetail: null,
    branchUsername: null,
    userProvince: null,

    ischangepassword: false,

    requestusers: [],
    b2bchangeinfo: null,

    getSubB2BList: [],

    selectedb2busername: null,

    subb2bfullname: null,
    subb2bphoneno: null,
    subb2bid: null,

    promotionOptions: [
        { ID: 1, NAME: "ຮັບ" },
        { ID: 0, NAME: "ບໍ່ຮັບລາຄາໂປຣ" },
      ],
    selectedPromotionPrice: null,
    
  };
  },
  methods: {
    saveSubB2B(){
      if (this.subb2bfullname === null || this.subb2bphoneno === null ) {
      this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
      }else{

        this.$swal({
          title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonText: "ຕ້ອງການ",
          cancelButtonText: "ບໍ່ຕ້ອງການ",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6"
        }).then(result => {
          if (result.value) {
                var params = {
                  b2busername: this.selectedb2busername,
                  subb2bfullname: this.subb2bfullname,
                  subb2bphoneno: this.subb2bphoneno,
                  username: this.username
                };

              RestAPI.saveSubB2B(params)
                .then(() => {
                  this.getSubB2B(this.selectedb2busername);
                  this.$swal("ບັນທຶກ B2B ຍ່ອຍ ສຳເລັດ!", "", "success");
                
                })
                .catch(error => {
                  console.log(error);
                  if (error == "Error: Request failed with status code 400") {
                    this.$swal("Check Input Data", "", "error");
                  } else {
                    this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                  }
                });
              }
        });
      }

    },

    openSaveSubB2BForm() {
      this.activeTab = 4;
      this.saveB2BAction = true;
      this.updateB2BAction = false;
      this.subb2bfullname= null;
      this.subb2bphoneno= null;
     
    },

    updateSubB2B() {
      if (this.subb2bfullname === null || this.subb2bphoneno === null ) {
      this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
      }else{

        this.$swal({
          title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonText: "ຕ້ອງການ",
          cancelButtonText: "ບໍ່ຕ້ອງການ",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6"
        }).then(result => {
          if (result.value) {
                var params = {
                  subb2bid: this.subb2bid,
                  subb2bfullname: this.subb2bfullname,
                  subb2bphoneno: this.subb2bphoneno,
                  username: this.username
                };

              RestAPI.updateSubB2B(params)
                .then(() => {
                  this.getSubB2B(this.selectedb2busername);
                  this.$swal("ແກ້ໄຂ B2B ຍ່ອຍ ສຳເລັດ!", "", "success");
                
                })
                .catch(error => {
                  console.log(error);
                  if (error == "Error: Request failed with status code 400") {
                    this.$swal("Check Input Data", "", "error");
                  } else {
                    this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                  }
                });
              }
        });
      }
      
    },

    updateSubB2BForm(data){
      this.saveB2BAction = false;
      this.updateB2BAction = true;

      this.subb2bfullname = data.FULLNAME;
      this.subb2bphoneno = data.PHONENO; 
      this.subb2bid = data.ID;
    },

    updateByUserRequest(username){
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6"
      }).then(result => {
        if (result.value) {
          var params = {
            b2busername: username,
            username: this.username
          };
          RestAPI.updateByUserRequest(params)
            .then((res) => {
              if(res.data.result==='01'){
                this.$swal("ບໍ່ສາມາດດຳເນີນການໄດ້", "", "warning"); 
              }else{
                this.$swal("ດຳເນີນການສຳເລັດ!", "", "success"); 
                this.getB2bUser();
              }
              

            })
            .catch(error => {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            });
        }
      });
    },

    isChangePassword(){
      this.ischangepassword = true;
    },
    getCountry() {
      RestAPI.getCountry()
        .then(res => {
          // console.log("con: "+ JSON.stringify(res.data))
          this.countryList = res.data;
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    onCountrySelected() {
      
      RestAPI.getProvincebyCountry(this.SelectedCountry.ID)
        .then(res => {
          // console.log("country selected...")
          this.ProvinceList = res.data;
          this.SelectedProvince= null;
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
  
    // onCountrySelected() {
    //   // this.isProvinceSelected = false;
    //   console.log("selected country: "+ JSON.stringify(this.selectedCountry))
    //   console.log("selected country ID: "+ JSON.stringify(this.selectedCountry.ID))
      
    //   this.getProvince();
    //   this.selectedProvince= null;
      
    // },
    getProvince(){
      RestAPI.getProvincebyCountry(this.selectedCountry.ID)
        .then(res => {
          // console.log("country selected...")
          this.provinceList = res.data;
          
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    saveUser() {
      // console.log("this.selectedProvince.ID: " + this.selectedProvince.length)
      if (
        this.b2busername === null ||
        this.b2buserpassword === null ||
        this.fullname === null ||
        this.company === null ||
        this.phoneno === null ||
        this.SelectedCountry === null ||
        this.SelectedProvince === null ||
        this.selectedPromotionPrice === null ||
        this.district === null ||
        this.village === null
      ) {
        this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
      }else if (
        this.b2buserpassword != this.reb2buserpassword 
      ) {
        this.$swal("ລະຫັດຜ່ານບໍ່ກົງກັນ", "", "error");
      }else if(this.roleid == 7 && this.SelectedProvince.ID != this.userProvince){ 
        //  console.log("this.SelectedProvince.ID:" + this.SelectedProvince.ID)
        //  console.log("this.userProvince: " + this.userProvince)
         this.$swal("ກະລຸນາເລືຶອກແຂວງ ທີ່ຂຶ້ນກັບຕົນເອງ", "", "error");
      } else {
        var params = {
          b2busername: this.b2busername,
          b2buserpassword: this.sha2(this.b2buserpassword),
          fullname: this.fullname,
          company: this.company,
          phoneno: this.phoneno,
          provinceid: this.SelectedProvince.ID,
          district: this.district,
          village: this.village,
          moredetail: this.moredetail,
          roleid: 8,
          username: this.username,
          isproprice: this.selectedPromotionPrice.ID,
          userProvince: this.userProvince
        };
        // console.log("params: " + JSON.stringify(params))
        RestAPI.saveB2bUser(params)
          .then(res => {
            // console.log("data: " + JSON.stringify(res.data))
            if (res.data == "duplicate username") {
              this.$swal(
                "ຊື່ໃຊ້ລະບົບຊຳ",
                "-",
                "error"
              );
              return false;
            }

            if (res.data == "duplicate fullname") {
              this.$swal(
                "ຊື່ເຕັມຊ້ຳ",
                "-",
                "error"
              );
              return false;
            }


            if (res.data == "duplicate phoneno") {
              this.$swal(
               "ເບີໂທຊ້ຳ",
                "-",
                "error"
              );
              return false;
            }
              
            this.$swal("ສ້າງ User ສຳເລັດ!", "", "success");
            
            this.b2busername= null;
            this.b2buserpassword= null;
            this.fullname= null;
            this.company = null;
            this.SelectedCountry = null;
            this.SelectedProvince = null;
            this.district= null;
            this.village = null;
            this.phoneno= null;
            this.moredetail = null;
            this.selectedPromotionPrice = null;
            this.getB2bUser();
            this.activeTab = 1;
            // console.log(res);
          })
          .catch(error => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
      }
    },
    getB2bUser() {
      // console.log("this.branchProvinceid: " + this.branchProvinceid)
      RestAPI.getB2bUserByStatus(this.branchUsername)
        .then(res => {
          // console.log("lsit:"+ JSON.stringify(res.data))
          this.activeusers = res.data.activeusers;
          this.inactiveusers = res.data.inactiveusers;
          this.requestusers = res.data.requestuser;
          this.b2bchangeinfo = `ຜູ້ໃຊ້ ຂໍປ່ຽນຂໍ້ມູນ (${this.requestusers.length})`;
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getSubB2B(b2busername){
      this.activeTab = 4;
      this.selectedb2busername = b2busername;
      RestAPI.getSubB2B(this.selectedb2busername)
        .then(res => {
          this.getSubB2BList = res.data;
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    updateUserForm(data) {
     
      this.activeTab = 0;
      this.saveAction = false;
      this.updateAction = true;
      this.b2buserid = data.USERID;
      this.b2busername = data.USERNAME;
      this.oldfullname = data.FULLNAME;
      this.fullname = data.FULLNAME;
      this.phoneno = data.PHONENO;
      this.oldphoneno = data.PHONENO;  
      this.company = data.COMPANY;
      this.moredetail = data.DETAIL;
      this.SelectedCountry ={"ID": data.COUNTRYID,"NAME": data.COUNTRYNAME};      
      this.SelectedProvince ={"ID": data.PROVINCEID,"NAME": data.PROVINCENAME};
      this.selectedPromotionPrice = {"ID": data.ISPROPRICE,"NAME": data.ISPROPRICE == 1 ? 'ຮັບ' : 'ບໍ່ຮັບລາຄາໂປຣ'};
      this.district = data.DISTRICT;
      this.village = data.VILLAGE;
      
      
    },
    openSaveUserForm() {
      this.activeTab = 0;
      this.saveAction = true;
      this.updateAction = false;
      this.b2busername= null;
      this.fullname= null;
      this.company = null;
      this.SelectedCountry = null;
      this.SelectedProvince = null;
      this.district= null;
      this.village = null;
      this.phoneno= null;
      this.moredetail = null;
    },
    updateUser() {
      // console.log("this.b2busername: "+ JSON.stringify(this.b2busername));
      // console.log("this.b2buserpassword: "+ JSON.stringify(this.b2buserpassword));
      // console.log("this.fullname: "+ JSON.stringify(this.fullname));
      // console.log("this.company: "+ JSON.stringify(this.company));
      // console.log("this.phoneno: "+ JSON.stringify(this.phoneno));
      // console.log("this.SelectedCountry: "+ JSON.stringify(this.SelectedCountry));
      // console.log("this.district: "+ JSON.stringify(this.district));
      // console.log("this.village: "+ JSON.stringify(this.village));

      if(this.ischangepassword == true){
        if (this.b2buserpassword === null){
          this.$swal("ກະລຸນາປ້ອນລະຫັດຜ່ານ", "", "error");
            return false;
        }else if(this.b2buserpassword != this.reb2buserpassword) {
           
            this.$swal("ລະຫັດຜ່ານບໍ່ກົງກັນ", "", "error");
            return false;
        }
      }


      if (this.b2busername === null ||
        this.fullname === null ||
        this.company === null ||
        this.phoneno === null ||
        this.SelectedCountry === null ||
        this.SelectedProvince === null ||
        this.district === null ||
        this.village === null ||
        this.c === null) {
      this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
      }else if(this.roleid == 7 && this.SelectedProvince.ID != this.userProvince){ 
         this.$swal("ກະລຸນາເລືຶອກແຂວງ ທີ່ຂຶ້ນກັບຕົນເອງ", "", "error");
      }else{  
         
          var params = {
          userid: this.b2buserid,
          b2busername: this.b2busername,
          ischangepassword: this.ischangepassword,
          b2buserpassword: this.ischangepassword ? this.sha2(this.b2buserpassword) : '',
          oldfullname: this.oldfullname,
          fullname : this.fullname,
          oldphoneno : this.oldphoneno,
          phoneno : this.phoneno,
          company: this.company,
          country: this.SelectedCountry.ID,
          province: this.SelectedProvince.ID,
          district: this.district,
          village: this.village,
          moredetail: this.moredetail,
          isproprice: this.selectedPromotionPrice.ID,
          username: this.username
        };

        // console.log("pa: " + JSON.stringify(params))
      
        RestAPI.updateDasmUser(params)
          .then(res => {
            // console.log("data: "+ JSON.stringify(res.data))
        
              if (res.data == "duplicate phoneno") {
                this.$swal(
                "ເບີໂທຊ້ຳ",
                  "-",
                  "error"
                );
                return false;
              }

              this.$swal("ແກ້ໄຂ User ສຳເລັດ!", "", "success");

            this.activeTab = 1;
            this.saveAction = true;
            this.updateAction = false;
            this.b2busername= null;
            this.b2buserpassword= null;
            this.fullname= null;
            this.company = null;
            this.SelectedCountry = null;
            this.SelectedProvince = null;
            this.district= null;
            this.village = null;
            this.phoneno= null;
            this.moredetail = null;
            this.selectedPromotionPrice = null;
            this.getB2bUser();
          })
          .catch(error => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
      }
      
    },
    changeUserStatus(userid,status){
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6"
      }).then(result => {
        if (result.value) {
          var params = {
            userid: userid,
            status: status,
            username: this.username
          };
          // console.log("par: "+ JSON.stringify(params ))
          RestAPI.changeUserDasmStatus(params)
            .then(() => {
              
              this.$swal("ດຳເນີນການສຳເລັດ!", "", "success");
              this.getB2bUser();

            })
            .catch(error => {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            });
        }
      });
    },

    resetPassword(userid){
      this.$swal({
        title: "ຕ້ອງານລີເຊັດລະຫັດຜ່ານ ແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6"
      }).then(result => {
        if (result.value) {
          var params = {
            userid: userid,
            username: this.username
          };
          RestAPI.resetPassword(params)
            .then(() => {
              
              this.$swal("ດຳເນີນການສຳເລັດ!", "", "success");

            })
            .catch(error => {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            });
        }
      });
    },
    

    print() {
      window.print();
    }
  },
  mounted() {
    this.roleid = this.user.ROLEID;
    this.userProvince = this.user.BSMPROVINCEID;
    this.username = this.user.USERNAME;
    this.branchUsername = this.user.ROLEID == 6 ? 'ALL' : this.user.USERNAME,
    this.getB2bUser();
    this.getCountry();
    // console.log("user:" + JSON.stringify(this.user))

  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
  .asterisk{
    color: red !important;
  }

  .custom-label-class {
  /* Add your custom CSS styles here */
  color: red; /* For example, setting the color to red */
}
  
</style>
